<template lang="pug">
  div(data-testid="card-tab-overall")
    app-layout
      template(slot="left")
        .bcard-btnbar.clearfix
          .pull-right
            .btn-group(v-if="isCardAddable")
              router-link.btn.btn-success(:to="{name: 'addcard-manual-clone', params: { sidPerson, item: data }}", title="この人物に名刺を追加" data-testid="btn-card-add-to-person")
                span.fa.fa-plus
              a.btn.btn-success.dropdown-toggle(href='#', data-toggle='dropdown' data-testid="btn-card-add-to-person-pulldown")
                span.fa.fa-caret-down
              ul.dropdown-menu
                li
                  router-link(:to="{name: 'addcard-manual-clone', params: { sidPerson, item: data }}")
                    i.fa.bcard-fa-card-plus-pencil.fa-fw.text-red
                    |
                    |
                    | 直接入力して登録
                li
                  router-link(:to="{name: 'addcard-image-clone', params: { sidPerson, item: data }}")
                    i.fa.bcard-fa-card-plus-image.fa-fw.text-light-blue
                    |
                    |
                    | 画像から登録
            |
            |
            a.btn.btn-primary(v-if="isCardEditable" title="変更", data-testid="-btn-edit" @click.prevent="openEditModal")
              i.fa.fa-edit
            |
            |
            func-send-to-nisfa(btn-level="primary", :checked-items="[data]")
            |
            |
            router-link.btn.btn-primary(v-if="data.sid_person && (isMgmt || isCardExchanged)", :to="{name: 'merge-persons-detail', params: {id: data.sid_person}}" data-testid="-btn-duplicate") 同一人物設定
            |
            |
            template(v-if="isMgmt")
              .btn-separator
              |
              |
              func-del-person(:sid-person="data.sid_person", @success="$emit('delete')")

          func-favorite(v-model="data.isFavorite", :sid-person="data.sid_person", icon="icon")

        card-view(:bcard="data")

        hr

        card-tab-overall-socials(v-model="data.sid_person", :editable="isSocialsEditable")

        hr

        card-tab-overall-attachs(v-model="data.sid_person", :editable="isAttachsEditable")

      template(slot="right")
        .-widget
          card-tab-overall-openflag(v-model="data.person.openflag", :editable="isOpenflagEditable", :sid-person="data.sid_person")

        .-widget
          card-tab-overall-tags(v-model="data.tags", :editable="isTagsEditable", :sid-person="data.sid_person")

        .-widget
          card-tab-overall-memo(v-model="data.sid_person" :editable="isMemoEditable")

        .-widget
          card-tab-overall-pvmemo(v-if="isPvMemoViewable", v-model="data.sid_person")

        .-widget
          card-tab-overall-pvkeywords(v-if="isPvKeywordsViewable", v-model="data.sid_person")

        .-widget
          h5 最終更新
          | {{data.upduser_full_name}}
          br
          | {{data.updated}}

    portal(to="modal")
      edit-card(v-model="editModal", :isCardNotProxing="isCardNotProxing")
</template>

<script>
import AppModal from '@/components/templates/AppModal'
import AppLayout from '@/components/templates/AppLayout'
import FuncFavorite from '@/components/organisms/functions/FuncFavorite'
import FuncDelPerson from '@/components/organisms/functions/FuncDelPerson'
// import FuncDelExchange from '@/components/organisms/functions/FuncDelExchange'
import FuncSendToNisfa from '@/components/organisms/functions/FuncSendToNisfa'
import CardView from '@/components/organisms/views/CardView'
import CardTabOverallSocials from './CardTabOverallSocials'
import CardTabOverallAttachs from './CardTabOverallAttachs'
import CardTabOverallOpenflag from './CardTabOverallOpenflag'
import CardTabOverallTags from './CardTabOverallTags'
import CardTabOverallMemo from './CardTabOverallMemo'
import CardTabOverallPvmemo from './CardTabOverallPvMemo'
import CardTabOverallPvkeywords from './CardTabOverallPvKeywords'
import EditCard from './EditCard'
import RepositoryFactory from '@/repositories/RepositoryFactory'

const BcardRepository = RepositoryFactory.get('bcard')

export default {
  name: 'CardTabOverall',
  components: {
    AppModal,
    AppLayout,
    FuncFavorite,
    FuncDelPerson,
    FuncSendToNisfa,
    CardView,
    CardTabOverallSocials,
    CardTabOverallAttachs,
    CardTabOverallOpenflag,
    CardTabOverallTags,
    CardTabOverallMemo,
    CardTabOverallPvmemo,
    CardTabOverallPvkeywords,
    EditCard
  //   Loading
  },
  props: {
    sidPerson: { type: [String, Number], required: true },
    /**
     * @param {Object} POST /bcards のレスポンスのうち1件またはGET /persons/overview
     */
    value: { type: Object, required: true }
  },
  data () {
    return {
      data: {
        // 初期表示
        // full_name: '---',
        // full_kana: '---',
        // corporate_name: '---',
        // corporate_kana: '---',
        // company_name: '---',
        // company_kana: '---',
        // dept: '---',
        // post: '---',
        // dept_post: '---',
        // undefined対策
        person: {}
      },
      editModal: {
        isOpen: false,
        sidPerson: null
      }
    }
  },
  computed: {
    isCardAddable () {
      return (this.data.person.openflag === this.app_flag.ON) ||
        this.data.editablePublic === this.app_flag.ON
    },
    isCardExchanged () {
      // 交換者に含まれているかどうか
      return this.data.isExchanged === this.app_flag.ON
    },
    // 画像代行入力中かどうかを返す
    isCardNotProxing () {
      return this.data.isProxing !== this.app_flag.ON
    },
    // 名刺が変更可能かどうか
    isCardEditable () {
      // 管理モードまたはユーザーが最新名刺を交換している
      const hasOwnChanged = this.isMgmt || this.data.isLatestExchanged === this.app_flag.ON
      // 最新名刺である
      const isNewest = true

      return hasOwnChanged && isNewest
    },
    isSocialsEditable () {
      return this.isMgmt || this.isCardExchanged
    },
    isAttachsEditable () {
      return this.isMgmt || this.isCardExchanged
    },
    isOpenflagEditable () {
      return this.data.editablePublic === this.app_flag.ON
    },
    isTagsEditable () {
      // タグは非交換者でも変更できる
      return true
    },
    isMemoEditable () {
      // 共有メモは非交換者でも変更できる
      return true
    },
    isPvMemoViewable () {
      // 名刺管理モードのときは表示しない
      // 交換者以外は表示しない
      return !this.isMgmt && this.isCardExchanged
    },
    isPvKeywordsViewable () {
      // 名刺管理モードのときは表示しない
      // 交換者以外は表示しない
      return !this.isMgmt && this.isCardExchanged
    }
  },
  watch: {
    // storeのwatchの仕方は他にもある
    // https://stackoverflow.com/questions/43270159/vuejs-2-how-to-watch-store-values-from-vuex
    '$store.state.base.bcardListReloader' (bcardListReloader) {
      if (bcardListReloader) {
        this.reload()
      }
    },
    // isOpen (isOpen) {
    //   if (isOpen) {
    //     // watch valueが起動する
    //     this.reload()
    //   }
    // },
    value () {
      // createdの後にも起動する
      this.syncData()
    }
  },
  created () {
    this.syncData()
  },
  methods: {
    syncData () {
      this.data = this.value
      this.saveHistory()
    },
    reload () {
      this.$emit('reload', { sid_person: this.data.sid_person })
    },
    saveHistory () {
      // 名刺閲覧履歴の登録
      // 名刺管理モードの時は実行しない
      if (!this.isMgmt && this.data.id) {
        // 成否はスルー
        BcardRepository.touch(this.data.id)
      }
    },
    // 画像読み取りエラーを返す
    // TODO 使い道何だった？
    isImageError (item) {
      return item.imageError === this.app_flag.ON
    },
    openEditModal () {
      this.editModal.isOpen = true
      this.editModal.sidPerson = this.data.sid_person
    }
  }
}
</script>

<style lang="scss" scoped>
  /deep/ {
    .-layout-left, .-layout-right {
      //height: calc(100vh - 246px);
    }
  }
  .bcard-btnbar {
    margin-bottom: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/box/CardTabOverall.vue